import { IJobsBoardForm, IJobsBoardFormValues } from '../interfaces';

export const emptyJobsBoardForm: IJobsBoardForm = {
    [IJobsBoardFormValues.search]: undefined,
    [IJobsBoardFormValues.jobTypes]: {},
    [IJobsBoardFormValues.isRemote]: false,
    [IJobsBoardFormValues.isHybrid]: false,
    [IJobsBoardFormValues.location]: {},
};
